import axios from "axios";
import AuthService from "../auth/auth_service";

export default class LocalService extends AuthService {

  findAll() {
    return axios({
      method: "GET",
      url: this.api_url_intra + "local",
      withCredentials: true,
    }).then((res) => res.data);
  }
  findById(id) {
    return axios({
      method: 'get',
      url: this.api_url_intra + 'local/' + id,
      withCredentials: true,
    }).then((res) => res.data);
  }

}
